//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Model from "@/models/mobile";
import PayCommon from "./PayCommon";
import loadScript from "@/config/loadScript";
import requestBasicUrl from "@/config/anboUrl";
// import moment from "moment";
export default {
  components: {
    PayCommon,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  },
  data() {
    return {
      code: "",
      showViewer: false,
      passState: [
        { key: 1, value: "普通临时车" },
        { key: 2, value: "月卡车" },
        { key: 3, value: "免费车" },
        { key: 4, value: "临时车1" },
        { key: 5, value: "临时车2" },
        { key: 6, value: "临时车3" },
        { key: 7, value: "临时车4" },
        { key: 8, value: "临时车5" },
        { key: 9, value: "临时车6" },
        { key: 10, value: "临时车7" },
        { key: 11, value: "临时车8" },
        { key: 12, value: "临时车9" },
        { key: 13, value: "临时车10" },
        { key: 14, value: "贵宾车" }
      ],
      pageFlag: true,
      advInfo: {}
    };
  },
  computed: {
    ...mapGetters("mobile", {
      data: "getCarin"
    })
  },
  mounted() {
    this.createdFunc();
    if (
      this.data.parkNo != 442996 &&
      this.data.parkNo != 251105 &&
      this.data.parkNo != 151295 &&
      this.data.parkNo != 670540
    ) {
      // Model.getAdvertising_th({
      //   parkNo: this.data.parkNo,
      //   requestId: moment().format("x"),
      //   spaceDeviceType: 0,
      //   spaceSceneType: 6
      // }).then(res => {
      //   this.advInfo = res.data.data;
      // });
      Model.getAdvertising({
        parkNo: this.data.parkNo ? this.data.parkNo : "",
        number: 3
      }).then(res => {
        loadScript(`${requestBasicUrl}`, () => {
          const st = document.querySelector("#anbo-ad-st");
          if (st) {
            document.body.removeChild(st);
          }
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.id = "anbo-ad-st";
          script.innerHTML = `__anbo_adv_sdk__.init({appid: "${
            res.data.appid
          }", adPosId: 4,parkId: "${res.data.parkId}"})`;
          document.body.append(script);
          document.querySelector(".advwrap").innerHTML =
            "<anboadv @show='advShow'></anboadv>";
          window.advShow = function(res) {
            // console.log("============ree", res);
          };
        });
      });
    }
  },
  created() {
    if (this.$route.query.params) {
      sessionStorage.setItem("wxPayParams", this.$route.query.params);
    }
  },
  methods: {
    advLink() {
      window.location.href = this.advInfo.bidSeat.target;
    },
    createdFunc() {
      if (this.$route.params.carNo == 666) {
        this.pageFlag = false;
        this.wxPay();
      }
    },
    passStateFilter(value) {
      let state = this.passState.find(item => item.key == value);
      return state ? state.value : "";
    },
    async payReturn() {
      let { data } = await Model.payReturn({
        payMoney: 0,
        payTime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        payType: -1,
        orderNo: this.data.orderNo
      });
      data.success ? this.$layer.msg(data.msg) : this.$layer.msg(data.error);
      if (data.success) {
        this.$router.push(
          `/mobile/enterCar/${this.data.parkNo}/${this.data.tdid}`
        );
        localStorage.setItem("carNo", this.data.mediaNo);
      } else {
        this.$router.push(`/mobile/confirmMsg/${this.data.mediaNo}`);
      }
    },
    wxPay() {
      var params = JSON.parse(sessionStorage.getItem("wxPayParams"));
      params.parkNo = 0;
      if (params.pageType == "recharge") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              //this.$layer.msg(res.error)
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "renewalDetails") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              //this.$layer.msg(res.error)
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "openCardDetails") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              //this.$layer.msg(res.error)
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "MonitorRenewal") {
        this.$refs.payCommon.payByWx({
          params,
          fail: res => {
            //this.$layer.msg(res.error)
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          },
          paySuccess: res => {
            this.$layer.msg("支付成功");
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          },
          payFail: res => {
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          }
        });
      }
    },
    pay() {
      if (this.data.realityMoney == 0) {
        if (sessionStorage.getItem("isNoCar") == 1) {
          if (this.$route.params.carNo == 2) {
            Model.openPark({
              parkNo: this.data.parkNo,
              passNo: this.data.tdid,
              carNo: this.data.mediaNo,
              carType: this.data.passtype
            }).then(res => {
              this.$router.replace({ path: "/mobile/resultPay" });
              //防止页面后退
              history.pushState(null, null, document.URL);
              window.addEventListener("popstate", function() {
                history.pushState(null, null, document.URL);
              });
              //                          this.$router.push(`/mobile/resultPay`)
            });
          } else {
            this.payReturn();
          }
        } else {
          this.$layer.msg("费用为0，无需支付");
          if (this.$route.params.carNo == 2) {
            this.$router.push(
              `/mobile/branch/enterCar/${this.data.parkNo}/${this.data.tdid ||
                -1}`
            );
          } else {
            this.$router.push(
              `/mobile/enterCar/${this.data.parkNo}/${this.data.tdid || -1}`
            );
          }
        }
      } else {
        let params = {
          orderNo: this.data.orderNo,
          OrderAmount: this.data.realityMoney,
          gsBh: this.data.gsbh,
          xmBh: this.data.xmbh,
          parkNo: this.data.parkNo,
          tollPayRsq: this.data.tollPayRsq
        };
        if (this.data.mediaNo && this.data.parkname) {
          (params.OrderDesc = `${this.data.mediaNo}支付${
            this.data.parkname
          }停车费`),
            (params.orderDesc = `${this.data.mediaNo}支付${
              this.data.parkname
            }停车费`);
        }
        if (this.$isWx) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              this.$layer.msg(res.error);
              if (this.$route.params.carNo == 2) {
                this.$router.push(
                  `/mobile/branch/enterCar/${this.data.parkNo}/${this.data
                    .tdid || -1}`
                );
              } else {
                this.$router.push(`/mobile/confirmMsg/${this.res.mediaNo}`);
              }
            },
            paySuccess: res => {
              if (this.$route.params.carNo == 2) {
                if (this.data.ishave == 0) {
                  Model.openPark({
                    parkNo: this.data.parkNo,
                    passNo: this.data.tdid,
                    carNo: this.data.mediaNo,
                    carType: this.data.passtype
                  });
                }
                this.$router.replace({
                  path: `/mobile/branch/enterCar/${this.data.parkNo}/${this.data
                    .tdid || -1}`
                });
                //                              this.$router.push(`/mobile/branch/enterCar/${this.data.parkNo}/${this.data.tdid || -1}`)
              } else {
                this.$router.push(
                  `/mobile/enterCar/${this.data.parkNo}/${this.data.tdid}`
                );
              }
              localStorage.setItem("carNo", this.data.mediaNo);
            },
            payFail: res => {
              if (this.$route.params.carNo == 2) {
                this.$router.push(
                  `/mobile/branch/enterCar/${this.data.parkNo}/${this.data
                    .tdid || -1}`
                );
              } else {
                this.$router.push(`/mobile/confirmMsg/${this.res.mediaNo}`);
              }
            }
          });
        } else if (this.$isZfb) {
          this.$refs.payCommon.payByZfb({
            params,
            success: res => {
              Model.testCallback();
            },
            fail: res => {
              this.$layer.msg(res.error);
              if (this.$route.params.carNo == 2) {
                this.$router.push(
                  `/mobile/branch/enterCar/${this.data.parkNo}/${this.data
                    .tdid || -1}`
                );
              } else {
                this.$router.push(`/mobile/confirmMsg/${this.res.mediaNo}`);
              }
            }
          });
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/confirmPay.vue